import React from 'react';

const noop = () => {};

function ProgressStepper({ steps = [], currentKey, onSelect = noop, progress = 0 }) {
  const pct = Math.min(Math.max(progress || 0, 0), 1) * 100;
  const currentIndex = steps.findIndex((s) => s.key === currentKey);

  return (
    <div className="review-stepper">
      <div className="review-step-track">
        {steps.map((step, i) => {
          const statusKey = step.status || 'pending';
          const isActive = currentKey === step.key;
          const isCompleted = statusKey === 'approved';
          const isPast = i < currentIndex;

          return (
            <button
              key={step.key}
              type="button"
              className={`review-step-button${isActive ? ' is-active' : ''}${isCompleted ? ' is-completed' : ''}`}
              onClick={() => onSelect(step.key)}
              aria-current={isActive ? 'step' : undefined}
              title={step.label}
            >
              <span className={`review-step-indicator status-${statusKey}${isActive ? ' active' : ''}`}>
                {isCompleted ? (
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
                    <path d="M3 7.5L5.5 10L11 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                ) : (
                  <span className="review-step-number">{i + 1}</span>
                )}
              </span>
              <span className="review-step-label">{step.label}</span>
              {i < steps.length - 1 && (
                <span className={`review-step-connector${isCompleted || isPast ? ' filled' : ''}`} />
              )}
            </button>
          );
        })}
      </div>
      <div className="stepper-progress">
        <div className="stepper-progress-fill" style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}

export default ProgressStepper;
